<template>
  <div>
    <Modal
      :model="props.model?.modal"
      :modal-active="isModalOpen"
      :title="t('sessionExpired.title')"
      @close="handleClose"
      :key="componentKey"
    >
      <p>{{ t('sessionExpired.information') }}</p>
      <div class="modal-actions">
        <Button
          class="button"
          :model="props.model?.exportToPdfButton"
          :text="t('sessionExpired.exportToPdfButton')"
          :alt="t('sessionExpired.exportToPdfButton')"
          :is-disabled="false"
          @click="handleExportToPDF"
        >
        </Button>

        <Button
          class="button"
          :model="props.model?.refreshSessionButton"
          :text="t('sessionExpired.continueButton')"
          :alt="t('sessionExpired.continueButton')"
          :is-disabled="false"
          @click="handleRefreshSession"
        >
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script setup lang="ts">
import Modal from './Modal.vue'
import Button from './Button.vue'
import { t } from '../composables/Translation'
import { updateComponentKey } from '../composables/ComponentKey'
import type { SessionExpiredModal } from '../types/configuration/SessionExpiredModal'
import { useAidaSessionStore } from '../stores/aidaSessionStore'
import { useChatStore } from '../stores/chatStore'

const aidaSessionStore = useAidaSessionStore()
const chatStore = useChatStore()

const emit = defineEmits<{
  (e: 'close'): void
}>()

const props = defineProps<{
  model: SessionExpiredModal | undefined
  isModalOpen: boolean
}>()

function handleClose() {
  emit('close')
}

function handleExportToPDF() {
  window.print()
}

function handleRefreshSession() {
  chatStore.keepLastTwoMessages()
  aidaSessionStore.setAidaSessionExpired(false)
}

let componentKey = updateComponentKey(props)
</script>
<style scoped lang="scss">
.modal-actions {
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.button {
  font: inherit;
  font-size: 14px;
  background: var(--background-color);
  color: #000;
  border: 1px solid var(--text-color);
  border-radius: 12px;
  padding: 8px 16px;
  cursor: pointer;
  align-self: flex-end;
  transition:
    transform 120ms ease,
    background-color 120ms ease,
    color 120ms ease,
    border-color 120ms ease;

  &:hover {
    background-color: rgba(59, 67, 82, 0.06);
  }
  &:active {
    transform: scale(0.96);
  }
  &:focus-visible {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }
}
</style>
